import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ac0b565"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "headline" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "twitter-div" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: "layout__container",
    style: _normalizeStyle(_ctx.backgroundStyle)
  }, [
    _createElementVNode("section", {
      class: _normalizeClass({'layout__twitterheadline-container' : _ctx.item.headline})
    }, [
      (_ctx.item.headline)
        ? (_openBlock(), _createElementBlock("h1", {
            key: 0,
            class: "layout__headline textfit__headline",
            style: _normalizeStyle({ color: _ctx.item.headlineColor })
          }, [
            _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.item.headline), 1)
          ], 4))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("section", {
      class: _normalizeClass({'layout__twitter-container' : _ctx.item.headline})
    }, _hoisted_3, 2)
  ], 4))
}